// extracted by mini-css-extract-plugin
export var emptyState = "_6h-d";
export var statCard = "_6h-c";
export var table = "_6h-0";
export var tableCell = "_6h-4";
export var tableCellClickable = "_6h-5 _6h-4";
export var tableCellDefault = "_6h-6 _6h-4";
export var tableCellEmpty = "_6h-8";
export var tableCellWithValue = "_6h-7";
export var tableContainer = "_6h-e";
export var tableHeaderWeight = "_6h-1";
export var tableHeaderZone = "_6h-2";
export var tableRowHeader = "_6h-3";
export var viewModeButton = "_6h-9";
export var viewModeButtonActive = "_6h-a _6h-9";
export var viewModeButtonInactive = "_6h-b _6h-9";